import {
  CreateGUFAddRealisedInstallationTask,
  EditGUFAddRealisedInstallationTask,
} from "@nens/brostar/uploadapi-client";
import { SchemaForFormData } from "@nens/shared-utils";

import { getDocsLinkMarkdown, getTitleAddon } from "@/libs/form-utils";
import { FormType } from "@/types/form-types";

import { pickGufLibraryFields } from "./guf-schema-library";

const sharedTitle = (type: FormType | undefined) =>
  `GUF Gerealiseerde installatie toevoegen ${getTitleAddon(type)}`;
const sharedDescription = `Dit is het GUF gerealiseerde installatie toevoegen formulier. ${getDocsLinkMarkdown(
  "GUF"
)}`;

const sharedSourcedocumentData = {
  type: "object" as const,
  title: "Brondocumentgegevens",
  required: ["realisedInstallationId", "installationFunction", "realisedLoopPos", "startValidity"],
  properties: {
    ...pickGufLibraryFields([
      "realisedInstallationId",
      "installationFunction",
      "realisedLoopPos",
      "startValidity",
      "realisedLoops",
      "realisedSurfaceInfiltrations",
      "realisedWells",
    ]),
  },
};

const getGufAddRealisedInstallationCreateSchema = (
  type: FormType | undefined
): SchemaForFormData<CreateGUFAddRealisedInstallationTask> => ({
  type: "object",
  title: sharedTitle(type),
  description: sharedDescription,
  required: ["metadata", "sourcedocumentData"],
  properties: {
    metadata: {
      type: "object",
      title: "Metadata",
      required: ["projectNumber", "deliveryAccountableParty", "qualityRegime", "broId"],
      properties: pickGufLibraryFields([
        "projectNumber",
        "qualityRegime",
        "deliveryAccountableParty",
        "broId",
      ]),
    },
    sourcedocumentData: sharedSourcedocumentData,
  },
});

const getGufAddRealisedInstallationEditSchema = (
  type: FormType | undefined
): SchemaForFormData<EditGUFAddRealisedInstallationTask> => ({
  type: "object",
  title: sharedTitle(type),
  description: sharedDescription,
  required: ["metadata", "sourcedocumentData"],
  properties: {
    metadata: {
      type: "object",
      title: "Metadata",
      required: [
        "projectNumber",
        "deliveryAccountableParty",
        "qualityRegime",
        "broId",
        "correctionReason",
      ],
      properties: {
        ...pickGufLibraryFields([
          "projectNumber",
          "qualityRegime",
          "deliveryAccountableParty",
          "correctionReason",
        ]),
        broId: { ...pickGufLibraryFields(["broId"]).broId, readOnly: true },
      },
    },
    sourcedocumentData: sharedSourcedocumentData,
  },
});

export function getGufAddRealisedInstallationSchema(args: {
  type: FormType | undefined;
  isEditing: true;
}): SchemaForFormData<EditGUFAddRealisedInstallationTask>;
export function getGufAddRealisedInstallationSchema(args: {
  type: FormType | undefined;
  isEditing: false;
}): SchemaForFormData<CreateGUFAddRealisedInstallationTask>;
export function getGufAddRealisedInstallationSchema(args: {
  type: FormType | undefined;
  isEditing: boolean;
}):
  | SchemaForFormData<EditGUFAddRealisedInstallationTask>
  | SchemaForFormData<CreateGUFAddRealisedInstallationTask>;
export function getGufAddRealisedInstallationSchema({
  type,
  isEditing,
}: {
  type: FormType | undefined;
  isEditing: boolean;
}) {
  return isEditing
    ? getGufAddRealisedInstallationEditSchema(type)
    : getGufAddRealisedInstallationCreateSchema(type);
}
